// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#password-help {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  & * {
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./frontend/app-users/page-password.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;;EAET;IACE,gBAAgB;EAClB;AACF","sourcesContent":["#password-help {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n\n  & * {\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
